"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useUserSummary } from "@/lib/api/user";
import { isLanguageCode, readLocaleCookie, setLocaleCookie } from "@/lib/language";

/**
 * Applies a logged-in user's persisted language across devices. When the
 * backend reports a `user.language` that differs from the local `locale`
 * cookie, this rewrites the cookie and reloads once so the SSR render picks up
 * the stored choice (e.g. on a fresh browser where the cookie is unset).
 *
 * Renders nothing. Guarded against reload loops: it compares against the actual
 * cookie value, which the reload will have set to match.
 */
export function LanguageSync() {
  const $ = _c(3);
  const {
    data: summary
  } = useUserSummary();
  const stored = summary?.user?.language;
  let t0;
  let t1;
  if ($[0] !== stored) {
    t0 = () => {
      if (!isLanguageCode(stored)) {
        return;
      }
      if (readLocaleCookie() === stored) {
        return;
      }
      setLocaleCookie(stored);
      window.location.reload();
    };
    t1 = [stored];
    $[0] = stored;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}